export const suggestions = {
  0.1: "No Action Needed / Due to closed Fresh Air Systems",
  1: "No Action Needed",
  2: "Decrease Fresh air for Unoccupied spaces/ Due to zero occupancy",
  3: "Increase Fresh air for Occupied areas/ Due to High Co2 Levels",
  4: "Decrease Aircondition in Unoccupied areas/ Due to zero occupancy",
  5: "Close Aircondition in Unoccupied areas/ Due to zero occupancy",
  6: "Decrease Aircondition in Occupied areas/ Due to low temp",
  7: "Increase Aircondition in Occupied areas / Due to high temp",
  8: "Decrease Heat in Unoccupied areas/ Due to zero occupancy",
  9: "Close Heat in Unoccupied areas/ Due to zero occupancy",
  10: "Increase Heat in Occupied areas/Due to low temp",
  11: "Decrease Heat in Occupied areas / Due to high temp",
  12: "Close Fresh air for Unoccupied spaces/ Due to zero occupancy",
  13: "Decrease Fresh air / Due to Low Co2 Levels",
  9999: "N/A",
};
